// extracted by css-extract-rspack-plugin
export default {"codeContainer":"TtnCg","code":"ALzoD"};